import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dailyProcessApi } from '../api/dailyProcessApi';
import { appToast } from '../../../../components/AppToast';

export function useDailyProcessRun() {
  const navigate = useNavigate();
  const todayStr = new Date().toISOString().split('T')[0];

  const [company, setCompany] = useState(0);
  const [branch, setBranch] = useState(0);
  const [department, setDepartment] = useState(0);
  const [employee, setEmployee] = useState(0);
  const [fromDate, setFromDate] = useState(todayStr);
  const [toDate, setToDate] = useState(todayStr);
  const [isProcessing, setIsProcessing] = useState(false);

  const [options, setOptions] = useState({
    companies: [{ value: 0, label: 'All Companies' }],
    branches: [{ value: 0, label: 'All Branches' }],
    departments: [{ value: 0, label: 'All Departments' }],
    employees: [{ value: 0, label: 'All Employees' }],
  });

  useEffect(() => {
    dailyProcessApi
      .getFilterOptions()
      .then((data) => {
        if (data) {
          setOptions({
            companies: data.companies || [{ value: 0, label: 'All Companies' }],
            branches: data.branches || [{ value: 0, label: 'All Branches' }],
            departments: data.departments || [{ value: 0, label: 'All Departments' }],
            employees: data.employees || [{ value: 0, label: 'All Employees' }],
          });
        }
      })
      .catch(() => {});
  }, []);

  const handleProcess = async () => {
    if (!fromDate || !toDate) {
      appToast.error('Please select valid From Date and To Date.');
      return;
    }
    if (new Date(fromDate) > new Date(toDate)) {
      appToast.error('From Date cannot be later than To Date.');
      return;
    }

    setIsProcessing(true);
    try {
      const res = await dailyProcessApi.runDailyProcess({
        company,
        branch,
        department,
        employee,
        fromDate,
        toDate,
      });
      appToast.success(res.message || 'Daily attendance processed successfully!');
      navigate('/payroll/daily-process');
    } catch (err) {
      const msg = err.response?.data?.detail || err.message;
      appToast.error(typeof msg === 'string' ? msg : 'Failed to process daily attendance.');
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    state: {
      company,
      branch,
      department,
      employee,
      fromDate,
      toDate,
      isProcessing,
      companyOptions: options.companies,
      branchOptions: options.branches,
      departmentOptions: options.departments,
      employeeOptions: options.employees,
    },
    actions: {
      setCompany,
      setBranch,
      setDepartment,
      setEmployee,
      setFromDate,
      setToDate,
      handleProcess,
    },
  };
}
